import React from 'react';
import logoSoriana from '../assets/images/icon/LOGOROJO.gif';

function AuthorizingPayment({ orderReferenceNumber }) {
  return (
    <div>
      <img src={logoSoriana} alt="logo" className="mx-auto w-full h-full" />
      <h1 className="txt-authorizing font-bold text-xl mb-2 sm:text-2xl md:text-4xl lg:text-4xl sm:-mt-[100px]">
        Autorizando tu pago
      </h1>
      <h2 className="text-gray-800 font-semibold text-base mb-2 sm:text-lg md:text-xl lg:text-2xl mt-6">
        Pedido no. <span id="orderReferenceNumber">{orderReferenceNumber}</span>
      </h2>
      <div className="mt-4">
        <p className="text-red-600 text-sm font-semibold leading-snug text-center sm:text-base md:text-m lg:text-l">
          No cierres ni actualices la página.
          <br />
          Esto podría causar problemas con tu pago.
        </p>
      </div>
    </div>
  );
}


export default AuthorizingPayment;
